(function() {
	'use strict';
	angular.module('app.core')
		.directive('leanNumericalCustomFilter', leanNumericalCustomFilter);

	leanNumericalCustomFilter.$inject = ['$translate'];
	function leanNumericalCustomFilter($translate) {
		var html = '<div class="numerical-menu" ng-show="$parent.filterFunctions.getViewValues().visibleMenu == ' + "'" + '{{filterId}}' + "'" + '" ng-click="$event.stopPropagation();">' +
						'<form name="numericalForm" novalidate>' +
							'<div class="numerical-header">' +
								'<div class="numerical-title"><span translate> {{filterName}}</span></div>' +
							'</div>' +
							'<div class="single-select-options">' +
								'<ul class="filter-menu">' +
									'<li ng-repeat="item in filterList" >' +
										'<a class="filterOption" href ng-click="$parent.$parent.filterFunctions.toggleItem(item, $parent.filterSearch, true);setFilterValue(item);">' +
											'<i class="fa fa-fw fa-lg fa-circle-thin" ng-hide="item.value === filterValue"></i>' +
											'<i class="fa fa-fw fa-lg fa-dot-circle-o" style="color:#0087E2" ng-show="item.value === filterValue"></i>' +
											'<span ng-bind-html="getItemLabel(item) | translate"></span>' +
										'</a>' +
									'</li>' +
								'</ul>' +
							'</div>' +
							'<div class="numerical-body" ng-show="filterValue === \'custom\'">' +
								'<div class="filter-dropdown form-group" ng-click="$event.stopPropagation();">' +
									'<select name="comparator" placeholder="{{\'Select Condition...\'|translate}}" ng-required="true" class="form-control" ng-model="filterComparator" ng-options="comp.name for comp in $parent.filterFunctions.comparators | filter:filterNotBetween() | filter:translateOption()" ng-click="openCustom()">' +
									'</select>' +
									'<input name="valueOne" type="number" class="form-control" ng-required="true" ng-model="filterValueOne" placeholder="' + $translate.instant('Enter value') + '...">' +
									'<input name="valueTwo" type="number" class="form-control" ng-required="filterComparator.abbr === ' + "'btw'" + '" ng-model="filterValueTwo" ng-show="filterComparator.abbr === ' + "'btw'" + '" placeholder="' + $translate.instant('Enter value') + '...">' +
								'</div>' +
							'</div>' +
							'<div class="numerical-footer">' +
								'<button class="button flat colored innerButton" ng-click="$parent.filterFunctions.cancelSelection()">' +
									'<span translate>Cancel</span>' +
								'</button>' +
								'<button class="button flat colored innerButton" data-testid="reportFilter-' + '{{filterId}}' + '-apply-btn" ng-disabled="$parent.filterFunctions.isReadOnly() || numericalForm.filterValue.$invalid || (filterValue === ' + "'custom'" + ' && (numericalForm.comparator.$invalid || numericalForm.valueOne.$invalid || numericalForm.valueTwo.$invalid))" ng-click="$parent.filterFunctions.applySelection($event, filterId)">' +
									'<span translate>Apply</span>' +
								'</button>' +
							'</div>' +
						'</form>' +
					'</div>';
		return {
			restrict:'EA',
			template: html,
			replace:true,
			transclude: true,
			scope: {filterName: '@',
											filterValue: '=',
											filterValueOne: '=',
											filterValueTwo: '=',
											filterComparator: '=',
											filterShowNotBtw: '=',
											filterList: '=',
											filterLabel: '@',
											filterId: '@'},
			link: function(scope, element, attrs) {
				scope.excludeNotBetweenOption = !scope.filterShowNotBtw;
				scope.openCustom = function() {
					scope.filterValue = 'custom';
				};
				scope.getItemLabel = function(item) {
					var val = scope.$eval(scope.filterLabel, item);
					var formatType = item.formatType;
					var format = item.format;
					if (formatType && format) {
						val = $filter(formatType)(val, format);
					}
					return val;
				};
				scope.setFilterValue = function(item) {
					scope.filterValue = item['value'];
					if (scope.filterValue !== 'custom') {
						scope.filterComparator = scope.filterValueOne = scope.filterValueTwo = undefined;
					}
					return false;
				};
				scope.filterNotBetween = function() {
					if (scope.excludeNotBetweenOption) {
						return function( item ) {
							return item.name != 'Not Between';
						};
					} else {
						return function( item ) {
							return true;
						};
					}
				};

				scope.translateOption = function () {
					return function(item) {
						item.name = $translate.instant(item.name);
						return item;
					};
				};
			}
		};
	}
})();
